import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Typography, Autocomplete, FormControl, InputLabel, Select, MenuItem, Button, TextField, Radio, RadioGroup, FormControlLabel, Checkbox } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Toastmessage from '../../components/Toast';
import { Link } from 'react-router-dom';
import { authApi } from '../../api/api';
import { useSelector } from 'react-redux';
import { logout } from '../../features/auth/AuthSlice';
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';

const rowsvalue = [
    { id: 1, metric: "Days", Jan: 22, Feb: 21, Mar: 21, Apr: 22, May: 22, Jun: 20, Jul: 22, Aug: 22, Sep: 22, Oct: 23, Nov: 19, Dec: 20, Cumulative: 254 },
    { id: 2, metric: "PTO/Sick", Jan: 4, Feb: 6, Mar: 0, Apr: 0, May: 2, Jun: 5, Jul: 1, Aug: 0, Sep: 0, Oct: 0, Nov: "-", Dec: "-", Cumulative: 18 },
    { id: 3, metric: "Team Member Month", Jan: 0, Feb: 0, Mar: 0, Apr: 0, May: 0, Jun: 0, Jul: 0, Aug: 0, Sep: 0, Oct: 0, Nov: "-", Dec: "-", Cumulative: 0 },
    { id: 4, metric: "CLE/PL CE", Jan: 0, Feb: 1, Mar: 0, Apr: 0, May: 0, Jun: 0, Jul: 0, Aug: 0, Sep: 0, Oct: 0, Nov: "-", Dec: "-", Cumulative: 1 },
    { id: 5, metric: "Working Days Total", Jan: 18, Feb: 14, Mar: 21, Apr: 22, May: 20, Jun: 17, Jul: 21, Aug: 20, Sep: 20, Oct: 23, Nov: 19, Dec: 20, Cumulative: 250.7 },
    { id: 6, metric: "Hrs/Day", Jan: 6.6, Feb: 6.6, Mar: 6.6, Apr: 6.6, May: 6.6, Jun: 6.6, Jul: 6.6, Aug: 6.6, Sep: 6.6, Oct: 6.6, Nov: 6.6, Dec: 6.6, Cumulative: "-" },
    { id: 7, metric: "Expected Hours", Jan: 118.8, Feb: 92.4, Mar: 138.6, Apr: 145.2, May: 132, Jun: 112.2, Jul: 138.6, Aug: 132, Sep: 151.8, Oct: 125.4, Nov: 132, Dec: 132, Cumulative: "1,551.00 H" },
    { id: 8, metric: "Hours Total", Jan: 118.5, Feb: 91.5, Mar: 134.8, Apr: 165.3, May: 129.6, Jun: 112.9, Jul: 138.8, Aug: "-", Sep: "-", Oct: "-", Nov: "-", Dec: "-", Cumulative: "1,049.50" },
    { id: 9, metric: "Credit Hours (-)", Jan: 0, Feb: 0, Mar: 0, Apr: 0, May: 0, Jun: 0, Jul: 0, Aug: "-", Sep: "-", Oct: "-", Nov: "-", Dec: "-", Cumulative: 0 },
    { id: 10, metric: "No Billable Charges (+)", Jan: 2.6, Feb: 4.8, Mar: 6.2, Apr: 2.5, May: 8.8, Jun: 1.2, Jul: 5.4, Aug: "-", Sep: "-", Oct: "-", Nov: "-", Dec: "-", Cumulative: 34.6 },
    { id: 11, metric: "Actual Hours", Jan: 121.1, Feb: 96.3, Mar: 141, Apr: 167.8, May: 138.4, Jun: 112.9, Jul: 138.8, Aug: "-", Sep: "-", Oct: "-", Nov: "-", Dec: "-", Cumulative: "1,049.50" },
    { id: 12, metric: "Over/(Under)", Jan: 2.3, Feb: 3.9, Mar: 2.4, Apr: 22.6, May: 6.4, Jun: 1.2, Jul: 0.2, Aug: "-", Sep: "-", Oct: "-", Nov: "-", Dec: "-", Cumulative: 39.7 },
    { id: 13, metric: "Cum Over/(Under)", Jan: 8.6, Feb: 30.2, Mar: 30.2, Apr: 30.2, May: 0.9, Jun: 0.9, Jul: 0.9, Aug: 0, Sep: 0, Oct: 0, Nov: 0, Dec: 0, Cumulative: 39.7 },
    { id: 14, metric: "Percent Complete %", Jan: "102%", Feb: "104%", Mar: "102%", Apr: "116%", May: "105%", Jun: "101%", Jul: "101%", Aug: "100%", Sep: "100%", Oct: "100%", Nov: "68%", Dec: "-", Cumulative: "68%" },
    { id: 15, metric: "Approved?", Jan: "Yes", Feb: "Yes", Mar: "Yes", Apr: "Yes", May: "Yes", Jun: "Yes", Jul: "Yes", Aug: "No", Sep: "No", Oct: "No", Nov: "No", Dec: "No", Cumulative: "No" },
];

const Paymentrow = [
    { id: 1, metric: 'Billed', Jan: '$51,006', Feb: '$37,257.5', Mar: '$54,020', Apr: '$65,365.5', May: '$52,790.5', Jun: '$52,713.5', Jul: '$44,306', Aug: '$0.0', Sep: '$0.0', Oct: '$0.0', Nov: '$0.0', Dec: '$0.0', Cumulative: '$357,459.0' },
    { id: 2, metric: 'Collected', Jan: '$47,810.92', Feb: '$391,77.31', Mar: '$55,629.69', Apr: '$63,121.8', May: '$48,069.19', Jun: '$52,713.5', Jul: '$57,244.31', Aug: '$0.0', Sep: '$0.0', Oct: '$0.0', Nov: '$0.0', Dec: '$0.0', Cumulative: '$354,944.0' },
    { id: 3, metric: 'Collection %', Jan: '93.4%', Feb: '105.5%', Mar: '102.98%', Apr: '96.57%', May: '91.06%', Jun: '108.6%', Jul: '99.06%', Aug: '0%', Sep: '0%', Oct: '0%', Nov: '0%', Dec: '0%', Cumulative: '99.3%' },
  ];

  const Bonusrow = [
    { id: 1, metric: '90% of Billed', Jan: '$4,590.55', Feb: '$33,531.75', Mar: '$48,618.00', Apr: '$58,828.95', May: '$47,511.45', Jun: '$47,442.15', Jul: '$39,875.40', Aug: '$0.0', Sep: '$0.0', Oct: '$0.0', Nov: '$0.0', Dec: '$0.0', Cumulative: '$0.0' },
    { id: 2, metric: 'Actual Collected', Jan: '$47,810.92', Feb: '$39,177.31', Mar: '$55,629.69', Apr: '$6,312.80', May: '$48,069.19', Jun: '$57,244.31', Jul: '$43,891.19', Aug: '$0.0', Sep: '$0.0', Oct: '$0.0', Nov: '$0.0', Dec: '$0.0', Cumulative: '$0.0' },
    { id: 3, metric: 'Bonus Base $1,600', Jan: '$1,600', Feb: '$1,600', Mar: '$1,600', Apr: '$1,600', May: '$1,600', Jun: '$1,600', Jul: '$1,600', Aug: '$0', Sep: '$0', Oct: '$0', Nov: '$0', Dec: '$0', Cumulative: '$0' },
    { id: 4, metric: '10% Extra', Jan: '$190.55', Feb: '$564.56', Mar: '$701.17', Apr: '$429.29', May: '$55.77', Jun: '$980.22', Jul: '$401.58', Aug: '0', Sep: '0', Oct: '0', Nov: '0', Dec: '0', Cumulative: '0' },
    { id: 5, metric: 'Total Bonus Earned', Jan: '$1790.55', Feb: '$2164.56', Mar: '$2301.17', Apr: '$2029.29', May: '$1655.77', Jun: '$2580.22', Jul: '$2001.58', Aug: '0', Sep: '0', Oct: '0', Nov: '0', Dec: '0', Cumulative: '$14523.13' },
  ];

const TimesheetYear = () => {
    const [dateType, setDateType] = useState('year');
    const currentYear = new Date().getFullYear();
    const [userOption, setUserOptions] = useState([]);
    const [rows, setRows] = useState(rowsvalue);

    const token = useSelector((state) => state.auth.token); // Get the token from Redux
    const userID = useSelector((state) => state.auth.id); // Get the userID from Redux

    const dispatch = useDispatch()
    const navigate = useNavigate();

    useEffect(() => {
        fetchUsers();
    }, [token, userID,]); // Run effect when token or userID changes


    // Define fetchLocations separately to reuse it
    const fetchUsers = async () => {
        const input_token = 'ALL_USERS'; // Replace with your actual token
        const apiUrl = 'list_of_firm_users'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                const statesArray = data.clients.map(user => ({
                    id: user.id,
                    full_name: user.full_name, // Match `getOptionLabel`
                    role_type: user.role_type
                }));

                setUserOptions(statesArray);
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };


    // Handle radio change
    const handleDateTypeChange = (event) => {
        setDateType(event.target.value);
        if (event.target.value == 'month') {
            navigate('/timesheet');
        }
    };

    const columns = [
        { field: "metric", headerName: "", width: 200 },
        { field: "Jan", headerName: "Jan", width: 100 },
        { field: "Feb", headerName: "Feb", width: 100 },
        { field: "Mar", headerName: "Mar", width: 100 },
        { field: "Apr", headerName: "Apr", width: 100 },
        { field: "May", headerName: "May", width: 100 },
        { field: "Jun", headerName: "Jun", width: 100 },
        { field: "Jul", headerName: "Jul", width: 100 },
        { field: "Aug", headerName: "Aug", width: 100 },
        { field: "Sep", headerName: "Sep", width: 100 },
        { field: "Oct", headerName: "Oct", width: 100 },
        { field: "Nov", headerName: "Nov", width: 100 },
        { field: "Dec", headerName: "Dec", width: 100 },
        { field: "Cumulative", headerName: "Cumulative", width: 150 },
    ];

    // Add checkboxes only for the "Approved?" row
    columns.forEach((col) => {
        if (col.field !== "metric") {
            col.renderCell = (params) => {
                if (params.row.metric === "Approved?") {
                    return (
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={params.value}
                                    onChange={(e) => {
                                        // Update the checkbox state in the rows
                                        const updatedRows = rows.map((row) => {
                                            if (row.metric === "Approved?") {
                                                return {
                                                    ...row,
                                                    [params.field]: e.target.checked,
                                                };
                                            }
                                            return row;
                                        });
                                        setRows(updatedRows);
                                    }}
                                    name={params.field}
                                />
                            }
                            label={params.value ? "Yes" : "No"}
                        />
                    );
                }
                return params.value;
            };
        }
    });



    // Example API call function to update the approval status
    const updateApprovalStatus = async (id, status) => {
        // Placeholder for your API call
        try {
            // Simulating API call with a success response
            return { success: true };
        } catch (error) {
            console.error('Error updating approval status:', error);
            return { success: false };
        }
    };





    // Calculate totals
    const totalRow = {
        id: 'total',
        week: '',
        billableHours: rows.reduce((sum, row) => sum + row.billableHours, 0),
        noChargeBillable: rows.reduce((sum, row) => sum + row.noChargeBillable, 0),
        creditOrRefund: rows.reduce((sum, row) => sum + row.creditOrRefund, 0),
        totalHours: rows.reduce((sum, row) => sum + row.totalHours, 0),
        requiredHours: rows.reduce((sum, row) => sum + row.requiredHours, 0),
        overUnder: rows.reduce((sum, row) => sum + row.overUnder, 0),
        noChargeNonBillable: rows.reduce((sum, row) => sum + row.noChargeNonBillable, 0),
        percentComplete: (rows.reduce((sum, row) => sum + row.percentComplete, 0) / rows.length).toFixed(2),
    };

    const allRows = [...rows, totalRow];

    const Productioncolumns = [
        { field: 'label', headerName: 'Required Production', flex: 1.5 },
        { field: 'value', headerName: '', flex: .6 },
        { field: 'date', headerName: 'PTO CLE/PL CE Dates', flex: 1, },
    ];

    const Productionrows = [
        { id: 1, label: 'Business Days in Month', value: 20 },
        { id: 2, label: 'Scheduled PTO', value: '0' },
        { id: 3, label: 'Scheduled CLE/PL CE', value: '0' },
        { id: 4, label: 'Total Working Days', value: '20.00', date: 'No PTO Leave' },
        { id: 5, label: 'This Month Required Hours', value: '132' },
        { id: 6, label: 'Month To Date Hours', value: '91.40' },
        { id: 7, label: 'Distance to Required Hours', value: '40.60' },
    ];

    return (
        <Box
            sx={{
                backgroundColor: 'var(--theme-bg-light)',
                padding: 3
            }}
        >
            <Box sx={{ margin: 'auto' }}>
                <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
                    Timesheet Reports
                </Typography>

                <Grid container spacing={2} alignItems="center">
                    {/* Left Section: Country and Date Picker */}
                    <Grid size={3}>
                        <FormControl fullWidth variant="outlined" sx={{ minWidth: 150 }}>
                            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>
                                Select User
                            </Typography>
                            <Autocomplete
                                options={userOption} // Populate with `userOption` state
                                getOptionLabel={(option) => option.full_name} // Access `full_name` field
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select user"
                                        variant="outlined"
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: { borderRadius: '8px' },
                                        }}
                                    />
                                )}
                                sx={{ width: '100%' }}
                            />
                        </FormControl>
                    </Grid>


                    <Grid size={2}>
                        <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>
                            {dateType === 'month' ? 'Month' : 'Year'}
                        </Typography>
                        <TextField
                            variant="outlined"
                            sx={{ width: '100%' }}
                            defaultValue={new Date().getFullYear()} // Sets the current year
                            InputProps={{
                                sx: { borderRadius: '8px' },
                                inputProps: dateType === 'year'
                                    ? { type: 'number', min: 2000, max: new Date().getFullYear() }
                                    : { type: 'month' },
                            }}
                        />
                    </Grid>



                    <Grid size={4}>
                        <FormControl
                            sx={{ display: 'flex', flexDirection: "row", alignItems: 'center', mt: 4 }}
                        >
                            <RadioGroup
                                sx={{ display: 'flex', flexDirection: "row", alignItems: 'center' }}
                                onChange={handleDateTypeChange}
                            >
                                <FormControlLabel value="month" control={<Radio size="small" />} label="Month" />
                                <FormControlLabel value="year" control={<Radio size="small" checked />} label="Year" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>

                    {/* Right Section: Export Button */}
                    <Grid size={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            sx={{
                                padding: '15px 30px',
                                borderRadius: "8px",
                                backgroundColor: 'var(--primary-color)',
                                color: '#fff',
                                '&:hover': { backgroundColor: 'var(--primary-color)' },
                            }}
                            className='primary-button'
                        >
                            Import Timesheet
                        </Button>
                    </Grid>
                </Grid>
            </Box>

            <Box sx={{ width: '100%', marginTop: '20px' }}>
                <DataGrid
                    rows={allRows}
                    columns={columns}
                    disableSelectionOnClick
                    pagination={false}
                    className="data-grid"
                    getRowClassName={(params) =>
                        params.id === 'total' ? 'total-row' : ''
                    }
                    sx={{
                        '& .total-row': {
                            fontWeight: 'bold',
                        },
                        '& .MuiDataGrid-columnHeader': {
                            fontWeight: 'bold',
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                        },

                        '& .MuiDataGrid-footerContainer': {
                            display: 'none',
                        },
                    }}
                />
            </Box>


            <Box sx={{ width: '100%', marginTop: '20px' }}>
                <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
                   Payment collection
                </Typography>
                <DataGrid
                    rows={Paymentrow}
                    columns={columns}
                    disableSelectionOnClick
                    pagination={false}
                    className="data-grid"
                    getRowClassName={(params) =>
                        params.id === 'total' ? 'total-row' : ''
                    }
                    sx={{
                        '& .total-row': {
                            fontWeight: 'bold',
                        },
                        '& .MuiDataGrid-columnHeader': {
                            fontWeight: 'bold',
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                        },

                        '& .MuiDataGrid-footerContainer': {
                            display: 'none',
                        },
                    }}
                />
            </Box>

            <Box sx={{ width: '100%', marginTop: '20px' }}>
                <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
                   Bonus
                </Typography>
                <DataGrid
                    rows={Bonusrow}
                    columns={columns}
                    disableSelectionOnClick
                    pagination={false}
                    className="data-grid"
                    getRowClassName={(params) =>
                        params.id === 'total' ? 'total-row' : ''
                    }
                    sx={{
                        '& .total-row': {
                            fontWeight: 'bold',
                        },
                        '& .MuiDataGrid-columnHeader': {
                            fontWeight: 'bold',
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                        },

                        '& .MuiDataGrid-footerContainer': {
                            display: 'none',
                        },
                    }}
                />
            </Box>
        </Box>
    );
};

export default TimesheetYear;
